// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.break-screen-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  min-width: 100vw;
  z-index: 9999;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: #fff;
  background-color: #333;
  margin: 0;
  padding: 0;
  border-radius: 0;
  overflow: hidden;
  gap: 160px;
}

.break-time-counter {
  text-align: center;
  max-width: 250px;
}

.break-instructions {
  max-width: 500px;
  text-align: left;
}

.break-instructions h3 {
  color: white;
  margin-bottom: 0.5rem;
}

.break-instructions ol {
  padding-left: 20px;
}

.break-instructions p,
.break-instructions li {
  color: #ccc;
}

.btn-warning {
  color: #333;
  background-color: #ffc107;
  border-color: #ffc107;
}

.btn-warning:hover {
  color: #fff;
  background-color: #e0a800;
  border-color: #d39e00;
}

.break-time-counter p {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}

.break-time-counter h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.break-time-counter button {
  padding: 0.5rem 1.5rem;
  font-size: 1.2rem;
}

@media (max-width: 1024px) {
  .break-screen-container {
    gap: 48px;
  }
  .break-instructions {
    font-size: 0.85rem;
  }
  .break-time-counter h1 {
    font-size: 1.5rem;
  }
  .break-time-counter p {
    font-size: 1rem;
  }
}
@media (max-width: 600px) {
  .break-screen-container {
    flex-direction: column;
    padding: 8px 0;
    gap: 0;
  }
  .break-time-counter {
    margin-bottom: 80px;
  }
  .break-instructions {
    font-size: 0.75rem;
    max-width: 98vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/examComponents/BreakScreen.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;;EAEE,WAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;AACF;;AAEA;EACE,iBAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,iBAAA;AACF;;AAEA;EACE;IACE,SAAA;EACF;EACA;IACE,kBAAA;EACF;EACA;IACE,iBAAA;EACF;EACA;IACE,eAAA;EACF;AACF;AAEA;EACE;IACE,sBAAA;IACA,cAAA;IACA,MAAA;EAAF;EAEA;IACE,mBAAA;EAAF;EAEA;IACE,kBAAA;IACA,eAAA;EAAF;AACF","sourcesContent":[".break-screen-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  min-height: 100vh;\n  min-width: 100vw;\n  z-index: 9999;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  background-color: #333;\n  margin: 0;\n  padding: 0;\n  border-radius: 0;\n  overflow: hidden;\n  gap: 160px;\n}\n\n.break-time-counter {\n  text-align: center;\n  max-width: 250px;\n}\n\n.break-instructions {\n  max-width: 500px;\n  text-align: left;\n}\n\n.break-instructions h3 {\n  color: white;\n  margin-bottom: 0.5rem;\n}\n\n.break-instructions ol {\n  padding-left: 20px;\n}\n\n.break-instructions p,\n.break-instructions li {\n  color: #ccc;\n}\n\n.btn-warning {\n  color: #333;\n  background-color: #ffc107;\n  border-color: #ffc107;\n}\n\n.btn-warning:hover {\n  color: #fff;\n  background-color: #e0a800;\n  border-color: #d39e00;\n}\n\n.break-time-counter p {\n  font-size: 1.2rem;\n  margin-bottom: 0.5rem;\n}\n\n.break-time-counter h1 {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.break-time-counter button {\n  padding: 0.5rem 1.5rem;\n  font-size: 1.2rem;\n}\n\n@media (max-width: 1024px) {\n  .break-screen-container {\n    gap: 48px;\n  }\n  .break-instructions {\n    font-size: 0.85rem;\n  }\n  .break-time-counter h1 {\n    font-size: 1.5rem;\n  }\n  .break-time-counter p {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .break-screen-container {\n    flex-direction: column;\n    padding: 8px 0;\n    gap: 0;\n  }\n  .break-time-counter {\n    margin-bottom: 80px;\n  }\n  .break-instructions {\n    font-size: 0.75rem;\n    max-width: 98vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
